import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";

const useEmailThread = (props) => {
    const { thread } = props;
    const [attachmentResponse, setAttachments] = useState([]);
    const [viewAttachmentConfig, setViewAttachmentConfig] = useState({
        open: false,
        id  : ""
    });
    const { axiosInstance, loading } = useAxios({ base: "panel" });

    const getAttachment = async () => {
        const response = await axiosInstance.get("/gmail/get-attachments", {
            params: {
                message_id: viewAttachmentConfig.id
            }
        });
        setAttachments(response.data);
    };

    const toggleView = (id = "") => {
        setViewAttachmentConfig((prev) => {
            return {
                open: !prev.open,
                id
            };
        });
    };

    useEffect(() => {
        if (viewAttachmentConfig.id) {
            getAttachment();
        }
    }, [viewAttachmentConfig]);

    useEffect(() => {
        toggleView();
    }, [thread]);

    return {
        loading,
        attachmentResponse,
        getAttachment,
        toggleView,
        viewAttachmentConfig
    };
};

export default useEmailThread;